var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found__img"},[_c('img',{attrs:{"src":require("@/assets/not_found.svg")}})]),_c('div',{staticClass:"not-found__title"},[_vm._v(" По вашему запросу "),_c('mark',[_vm._v("ничего не найдено")])]),_c('div',{staticClass:"not-found__comment"},[_vm._v("Попробуйте изменить параметры поиска")])])
}]

export { render, staticRenderFns }